import store from '@/store';

export default class AgentChatLoginEvent {
  constructor(body) {
    if (body.chat) return store.dispatch('channel/connectedChat');

    const error = {
      text: 'channelChat.errorConnect',
      type: 'error',
    };
    store.dispatch('showSnackbar', error);
  }
}
